<template>
  <div>
    <!--<ul class="clearfixed select_date">-->
    <!--<li class="fl">-->
    <!--<select v-model="mounths">-->
    <!--<option value="0">请选择查询月份</option>-->
    <!--<option value="1">1月份</option>-->
    <!--<option value="2">2月份</option>-->
    <!--<option value="3">3月份</option>-->
    <!--<option value="4">4月份</option>-->
    <!--<option value="5">5月份</option>-->
    <!--<option value="6">6月份</option>-->
    <!--<option value="7">7月份</option>-->
    <!--<option value="8">8月份</option>-->
    <!--<option value="9">9月份</option>-->
    <!--<option value="10">10月份</option>-->
    <!--<option value="11">11月份</option>-->
    <!--<option value="12">12月份</option>-->
    <!--</select>-->
    <!--</li>-->
    <!--<li class="fl search_btn" @click="searchPension">-->
    <!--查询-->
    <!--</li>-->
    <!--</ul>-->
    <ul class="fr operation_list">
      <li class="fl print_btn" @click="printTable">打印</li>
    </ul>
    <div id="printTable">

      <table class="table table_content" v-show="!loading">
        <caption class="table_box" style="font-size:16px;margin-bottom: 20px;">2019年基本养老金调整明细</caption>
        <tr>
          <td>姓名</td>
          <td colspan="2">{{tableInfo.username}}</td>
          <td>性别</td>
          <td>{{tableInfo.sex}}</td>
          <td>出生日期</td>
          <td colspan="2">{{tableInfo.birthday}}</td>
        </tr>
        <tr>
          <td>退休日期</td>
          <td>{{tableInfo.retirement_date}}</td>
          <td>退休类别</td>
          <td>{{tableInfo.retirement_type}}</td>
          <td>社会保障号</td>
          <td colspan="3">{{tableInfo.social_security_account}}</td>
        </tr>
        <tr>
          <td>退休单位</td>
          <td colspan="2">{{tableInfo.company_name}}</td>
          <td colspan="2">调整前基本养老金</td>
          <td colspan="3">{{tableInfo.last_month_pension}}</td>
        </tr>
        <tr>
          <td>累计缴费年限</td>
          <td colspan="2">{{tableInfo.accumulated_payment_date}}</td>
          <td colspan="2">2018年12月31日时年龄</td>
          <td colspan="3">{{tableInfo.years_old}}</td>
        </tr>
        <tr>
          <td>对应同类人员</td>
          <td colspan="2">{{tableInfo.retirement_position}}</td>
          <td colspan="2">单位管理码</td>
          <td colspan="3">{{tableInfo.company_id}}</td>
        </tr>
        <tr>
          <td colspan="8">2019年基本养老金调整明细</td>
        </tr>
        <tr>
          <td>序号</td>
          <td colspan="4">调整项目</td>
          <td colspan="3">调整金额（元/月）</td>
        </tr>
        <tr>
          <td>1</td>
          <td colspan="4">定额调整增加额</td>
          <td colspan="3">{{tableInfo.account}}</td>
        </tr>
        <tr>
          <td>2</td>
          <td colspan="4">按累计缴费年限调整增加额</td>
          <td colspan="3">{{tableInfo.account_by_years}}</td>
        </tr>
        <tr>
          <td>3</td>
          <td colspan="4">按调整前基本养老金调整增加额=调整前基本养老金*{{institution_proportion}}%</td>
          <td colspan="3">{{tableInfo.account_old}}</td>
        </tr>
        <tr>
          <td>4</td>
          <td colspan="4">高龄人员增发额</td>
          <td colspan="3">{{tableInfo.account_by_high}}</td>
        </tr>
        <tr>
          <td>5</td>
          <td colspan="4">取整进元补差额</td>
          <td colspan="3">{{tableInfo.gap_to_int}}</td>
           <!-- <td colspan="3">{{suppleMent}}</td> -->
        </tr>
        <tr>
          <td colspan="5">合计月增加额=1+2+3+4+5</td>
          <td colspan="3">{{tableInfo.account_total}}</td>
        </tr>
        <tr>
          <td colspan="5">调整后月基本养老金（含企业年金）</td>
          <td colspan="3">{{tableInfo.account_after}}</td>
        </tr>
      </table>
      <div class='explain_tip'>
        <div class="seal_time">
          <div class="seal">社保经办机构盖章: </div>
          <div class="print_time">打印时间:{{timeExplain}}</div>
        </div>
        <div class="explain_box">
          <h3 class="explain_title">说明: </h3>
          <p>1、本次基本养老金调整从2019年1月1日起执行，调整对象为2018年12月31日前已办理退休、退职手续的人员。</p>
          <p>2、定额调整:每人每月40元。 </p>
          <p>3、缴费年限挂钩:缴费年限15年及以下的部分，增加额为1.5元/年，增加额不足15元的，补足到15元;缴费年限15年以上至30年的部分，增加额为2.5元/年;缴费年限30年以上部分，增加额为3元 /年;缴费年限不满1年按1年计算。 </p>
          <p>4、月养老金挂钩:挂钩调整额=调整前基本养老金×2%;调整前基本养老金是指按本人本次调整 前月基本养老金(剔除职业年金和补发、代发金额);2014年10月1日至2018年12月31日期间按规定办 理退休手续的“中人”先按预发金额计算，待正式核定基本养老金后再重新核算并补差。增加额尾数 见厘进分，最多保留2位小数。</p>
          <p>5、高龄人员是指2018年12月31日前，女年满65周岁，男年满70周岁的退休人员。其中，女年满65周 岁不满80周岁，男年满70周岁不满80周岁的，每人每月增发30 元;男、女年满80周岁及以上的，每人 每月增发 60 元。<p>
          <p>6、取整进元补差额:因合计月增加额尾数不足1元的，需见角、分进元，如定额调整等前4项增加额 合计有小数的，需增加补差额至月调整总额取整进元。</p>
          <p>7、如有疑议，请联系单位经办人向社保经办机构查询核对。</p>
        </div>
      </div>
      <loading v-show="loading"></loading>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import loading from '../../libs/loading'
  import moment from 'moment'
  export default {
    name :'table2019',
    components:{
      loading
    },
    data () {
      return {
        id:this.$route.params.id,
        mounths:0,
        tableInfo:{},
        loading:true,
        institution_proportion:'',
        suppleMent:'',
        timeExplain:''
      }
    },
    mounted () {
      this.searchPension();
      this.getPayment();
      this.timeExplain=moment().format('YYYY/MM/DD');
    },
    methods:{
      remove_ie_header_and_footer:function() {
          var hkey_path;
          hkey_path = "HKEY_CURRENT_USER\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
          try {
          var RegWsh = new ActiveXObject("WScript.Shell");
          RegWsh.RegWrite(hkey_path + "header", "");
          RegWsh.RegWrite(hkey_path + "footer", "");
          } catch (e) {
          }
      },
      printTable:function(){
        this.remove_ie_header_and_footer();
        var bdhtml=window.document.body.innerHTML;
        var prnhtml=document.getElementById('printTable').innerHTML;
        document.getElementById('app').innerHTML=prnhtml;
        document.getElementById('app').children[0].className='table view_table';
        document.getElementById('app').children[1].className='explain_tip explain_tips';
        window.print();
        window.document.body.innerHTML=bdhtml;
        document.location.reload();
      },

      accAdd:function (arg1, arg2) {
        var r1, r2, m, c;
        try {
          r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
          r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
          var cm = Math.pow(10, c);
          if (r1 > r2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
          } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
          }
        } else {
          arg1 = Number(arg1.toString().replace(".", ""));
          arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
      },

      accSub:function (arg1, arg2) {
        var r1, r2, m, n;
        try {
          r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
          r1 = 0;
        }
        try {
          r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
          r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
      },


      searchPension:function(){
        axios.get('/user/getDetails',{
          params:{
            year:2019,
            id:this.id
          }
        }).then((response)=>{
          if(response.data.code==22000){
            if(response.data.result.constructor!=Array){
              this.tableInfo=response.data.result
            }

            let a=this.accAdd(Number(this.tableInfo.account),Number(this.tableInfo.account_by_years))
            let b=this.accAdd(Number(this.tableInfo.account_old),Number(this.tableInfo.account_by_high))
            let c=this.accAdd(Number(a),Number(b))+'';
            let d =this.accSub(Number(100),Number(c.split(".")[1]));
            this.suppleMent = (d * 0.01).toFixed(2);

            this.loading=false;
          }else if(response.data.code==50001){
            window.location.href='/#/login';
          }
        })
      },
      getPayment:function () {

        axios.get('/config/getAdjustment',{
          params:{
            year:2019,
          }
        }).then((response)=>{
          if(response.data.code==22000){
            this.institution_proportion=response.data.result.institution_proportion
          }else {
            console.log(response.data.message)
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .view_table{
    width: 1000px!important;
    padding-left: -100px !important;
  }
  td{
    border-right:1px solid #e1e7f6;
    text-align: center;
    width:12.5%;
  }
  .table{
    border-right: none;
  }
  .operation_list {
    li {
      cursor: pointer;
      padding-left: 30px;
      margin-left: 22px;
    }
  }
  .print_btn{
    background: url("../../../static/images/print.png") 5px center no-repeat;
    background-size: 18px 18px;
  }
  .select_date{
    li{
      margin-right: 10px;
    }
    select{
      border:1px solid #e1e7f6;
      height:28px;
      background-color: #fff;
    }
  }
  .search_btn{
    padding:0 10px;
    background: #00a5fa;
    color: #fff;
    height: 28px!important;
    line-height: 28px!important;
    border-radius: 5px;
    margin-top: 10px;
  }
  .table_box{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }

  .explain_tip{
    width: 80%;
    .seal_time{
       margin:60px 0;
       overflow:hidden;
      div{
        height: 22px;
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        text-align: left;
        line-height: 22px;
      }
      .seal{
        float: left;
      }
      .print_time{
        float:right;
        color: rgba(153, 153, 153, 1);
        text-align: right;
      }
    }
    .explain_box {
        h3{
          height: 22px;
          color: rgba(51, 51, 51, 1);
          font-size: 16px;
          text-align: left;
          line-height: 22px;
          margin-bottom: 10px;
        }
        p{
          line-height: 30px;
          color: rgba(102, 102, 102, 1);
          font-size: 14px;
          text-align: left;
        }
    }
  }
.explain_tips {
  width: 1000px !important;
}
@page {
  margin-bottom: 0mm;
  margin-top: 0mm;
}
</style>



// WEBPACK FOOTER //
// src/components/pension/table2019.vue